import { motion } from "framer-motion";
import { DecorativeLines } from "@/components/DecorativeLines";

// Heart SVG matching the ResQ logo style - minimal elegant version
const HeartButton = ({ className }) => (
  <svg 
    viewBox="0 0 100 90" 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M50 85 C20 55, 5 35, 5 25 C5 10, 20 5, 30 5 C40 5, 50 15, 50 25 C50 15, 60 5, 70 5 C80 5, 95 10, 95 25 C95 35, 80 55, 50 85Z"
      fill="#D4A000"
      stroke="#F5861A"
      strokeWidth="3"
    />
  </svg>
);

export const Cooperation = () => {
  return (
    <section
      id="wspolpraca"
      className="section-spacing bg-white dark:bg-[#0D0F12] relative"
      aria-label="Współpraca"
      data-testid="cooperation-section"
    >
      <DecorativeLines variant="curves-left" />
      <div className="w-full max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="text-[#EA8628] font-semibold text-sm uppercase tracking-wider">
            Współpraca
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#212738] dark:text-white">
            Współpraca z
            <span className="text-[#EA8628]"> ResQ</span>
          </h2>
        </motion.div>
        
        <motion.div
          className="mt-10 space-y-6 text-center max-w-4xl mx-auto"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <p className="text-[#504D4D] dark:text-white/80 leading-relaxed text-sm sm:text-base">
            <strong className="text-[#212738] dark:text-white">Centrum Kształcenia i Konsultacji ResQ</strong> to zaufany partner dla{" "}
            <strong className="text-[#212738] dark:text-white">producentów i dystrybutorów sprzętu medycznego</strong>, którzy poszukują rzetelnego{" "}
            <strong className="text-[#212738] dark:text-white">podwykonawcy w obszarze serwisu, logistyki oraz IT</strong>.
          </p>
          
          <p className="text-[#504D4D] dark:text-white/70 leading-relaxed text-sm sm:text-base">
            Przejmujemy operacyjne wsparcie Twojej marki - od realizacji czynności serwisowych i obsługi technicznej, 
            po kompleksową logistykę urządzeń. Dzięki temu możesz skupić się na rozwoju sprzedaży oraz budowaniu 
            długofalowych relacji z klientami. Działamy elastycznie, w pełnej zgodności ze standardami producenta 
            oraz obowiązującymi normami, dbając o ciągłość pracy urządzeń i satysfakcję użytkowników końcowych.
          </p>
          
          <p className="text-[#504D4D] dark:text-white/70 leading-relaxed text-sm sm:text-base">
            Dzięki przynależności do <strong className="text-[#212738] dark:text-white">Grupy Q</strong> oferujemy również{" "}
            <strong className="text-[#212738] dark:text-white">profesjonalne wsparcie IT</strong>, stanowiące realne wzmocnienie 
            obsługi posprzedażowej i procesów serwisowych.
          </p>
          
          <p className="text-[#504D4D] dark:text-white/70 leading-relaxed text-sm sm:text-base">
            Doświadczony zespół oraz sprawne zaplecze organizacyjne pozwalają nam zapewnić{" "}
            <strong className="text-[#212738] dark:text-white">terminowość, wysoką jakość oraz pełną transparentność działań</strong>. 
            Każdą współpracę traktujemy indywidualnie, dopasowując zakres usług do potrzeb oraz modelu biznesowego partnera.
          </p>
          
          <p className="text-[#504D4D] dark:text-white/80 leading-relaxed text-sm sm:text-base font-medium">
            Jeśli szukasz partnera, który <strong className="text-[#EA8628]">odciąży Twój zespół i wzmocni obsługę 
            posprzedażową Twojej marki</strong>, ResQ jest gotowe do współpracy.
          </p>
        </motion.div>

        {/* Heart-shaped Contact Button */}
        <motion.div
          className="mt-10 flex justify-center"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4, delay: 0.2 }}
        >
          <a
            href="#kontakt"
            className="group inline-flex items-center gap-3 px-5 py-3 rounded-full bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 hover:border-[#EA8628]/40 hover:bg-gray-50 dark:hover:bg-white/10 transition-all duration-300"
            data-testid="cooperation-contact-button"
          >
            <HeartButton className="w-6 h-6 group-hover:scale-110 transition-transform duration-300" />
            <span className="text-[#212738] dark:text-white/90 font-medium text-base group-hover:text-[#EA8628] dark:group-hover:text-white transition-colors duration-300">
              Skontaktuj się z nami
            </span>
          </a>
        </motion.div>
      </div>
    </section>
  );
};
